import React, { Component } from 'react';
import { Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import logo from './images/alumsumlogobetatm.png';
import fb from './images/fb.png';
import ig from './images/ig.png';
import linkd from './images/linkd.png';
import './css/navbar.css';
// import '..css/alum-style.css';

export default class AppNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen: false};
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (
            <Navbar className="navbar navbar-expand navbar-light bg-white">
                <div className="navbar-nav">
                    <NavbarBrand>
                        <NavLink
                            href={"/"}><img src={logo} alt="logo" className="navlogoresponsive"/>
                        </NavLink>
                        <NavItem>
                        <NavLink href="https://www.linkedin.com/company/35658148/admin/"><img src={linkd} alt="linkd"/></NavLink>
                    </NavItem>
                        <NavItem>
                        <NavLink
                            href="https://www.facebook.com/alumsum1/?modal=admin_todo_tour"><img src={fb} alt="fb"/></NavLink>
                    </NavItem>
                        <NavItem>
                        <NavLink href="https://www.instagram.com/alumsum/"><img src={ig} alt="ig"/></NavLink>
                    </NavItem>
                    </NavbarBrand>
                    {/* <Nav className="socialMedia">
                        <NavItem>
                        <NavLink href="https://www.linkedin.com/company/35658148/admin/"><img src={linkd} alt="linkd"/></NavLink>
                    </NavItem>
                        <NavItem>
                        <NavLink
                            href="https://www.facebook.com/alumsum1/?modal=admin_todo_tour"><img src={fb} alt="fb"/></NavLink>
                    </NavItem>
                        <NavItem>
                        <NavLink href="https://www.instagram.com/alumsum/"><img src={ig} alt="ig"/></NavLink>
                    </NavItem>
                    </Nav> */}
                </div>
            </Navbar>
        );
    }
}